module.exports = __webpack_public_path__ + "img/zhengzairebo.e939ce81.png";